module.exports = __webpack_public_path__ + "static/media/compare-new-vehicles.2fc0ea1e.svg";